/**
 * @file
 * Show / hide part of text in the block congress stages.
 */

(function ($, Drupal) {
  'use strict';

  Drupal.behaviors.secf_block_congress_stages = {
    attach: function (context, settings) {

      $('.block--congress-stages', context).once('secf-block-congress-stages').each(function () {
        var $block = $(this);
        var $blockItems = $(this).find('.field__item');
        var $button = $block.find('.js-toggle-text');

        if($block.find('.toggleable-text').length) {
          $block.addClass('js-has-toggleable-text');

          $button.on('click', function () {
            $button.toggleClass('js-active');
            $block.find('.toggleable-text').toggle();
            $blockItems.toggleClass('js-collapsed')
          });

          $blockItems.on('click', function () {
            if ($(window).width() > 991) {
              $button.toggleClass('js-active');
              $block.find('.toggleable-text').toggle();
              $blockItems.toggleClass('js-collapsed')
            }
          });
        }

      });

    }
  };
})(jQuery, Drupal);
